import React, { useContext, useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive'
import NameNaming from './components/Tabs/NameNaming';
import NameSpec from './components/Tabs/NameSpec';
import NameSize from './components/Tabs/NameSize';

import Content from './components/Content';
import BuilderContext from '../../builder/hooks/context';
import { device } from '../../const/device';
import pickBy from "lodash/pickBy";
import { trackStage, trackSubStage, trackTimeSpentOnStage } from '../../utils/Analytics';


function Name() {

  const Components = {
    naming: NameNaming,
    size: NameSize,
    specs: NameSpec
  };

  const isMobile = useMediaQuery({ query: `(${device.mobileL})` })
  const { builder } = useContext(BuilderContext);
  const [stageStartTime, setStageStartTime] = useState<number>(Date.now());

  const filteredComponents = pickBy(Components, (value, key) => {
    switch(key){
      case "naming":return builder?.options?.text;
      case "size": return isMobile;
      case "specs":return !(isMobile && !builder?.options?.sex && !builder?.options?.sleeve);
      default:return true;
    }
  })

  useEffect(() => {
    setStageStartTime(Date.now());

    return () => {
      trackTimeSpentOnStage('Specs', stageStartTime);
    };
  }, []);

  useEffect(() => {
    trackStage('Specs');
    trackSubStage('Specs', 'Naming');
  }, []);

  useEffect(() => {
    if(!builder?.animationState){
      builder?.setAnimationState(true);
      if(builder.modelData.surffaceList.length === 0){
        builder?.setCamera('back');
      }else{
        builder?.setCamera('front');
      }
    }
  }, []);

  // Tell the interaction layer we're on the Specs tab with Naming subtab (text interaction)
  useEffect(() => {
    builder?.setUiContext({ tab: 'Specs', specsSubtab: 'Naming' });
  }, []);

  return (
    <>
      <Content Components={filteredComponents} page='name' />
    </>
  );
}

export default React.memo(Name);
